import 'css-chunksrc/client/scenes/listDuplication/listsList/list/event/styles.scss';export default {
  "event": "_event_vednc_1",
  "contextualMenu": "_contextualMenu_vednc_8",
  "eventDetails": "_eventDetails_vednc_12",
  "name": "_name_vednc_22",
  "icon": "_icon_vednc_38",
  "taskAdvancement": "_taskAdvancement_vednc_42",
  "taskAdvancementWrapper": "_taskAdvancementWrapper_vednc_48",
  "removeIcon": "_removeIcon_vednc_61",
  "status": "_status_vednc_65",
  "allocations": "_allocations_vednc_72",
  "text": "_text_vednc_79",
  "tick": "_tick_vednc_85",
  "late": "_late_vednc_92",
  "displayContextualMenu": "_displayContextualMenu_vednc_103",
  "placeholder": "_placeholder_vednc_107"
};